module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/heading-sample-000e97b5027b88b50b278131181e1194.svg";